export default __webpack_public_path__ + "static/media/i177hp.67d18e06.webp";